export default {
    methods: {
        pushDataSubscribe() {
            dataLayer.push({'event':'Popup_sub_datalayerpush'});
        }
    }
}